const initialState = {
	category: {
		id: null,
		ja: null,
		en: null,
	},
	childCategory: [],
	breadcrumb: [],
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {
	if (action.type === 'ARTICLES_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.category.id = action.payload.category.id;
		newState.category.ja = action.payload.category.ja;
		newState.category.en = action.payload.category.en;
		newState.childCategory = action.payload.childCategory;
		newState.breadcrumb = action.payload.breadcrumb;
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else {
		return state;
	}
}
